<template>
  <div class="modal fade" id="registerCustomer" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-bottom-0">
          <button type="button" class="btn-close d-none" data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="text-center mb-4">
            <div class="avatar-md mx-auto mb-4">
              <div class="avatar-title bg-light rounded-circle text-primary h1">
                <i class="mdi mdi-account-multiple-plus"></i>
              </div>
            </div>

            <div v-if="message !== null" class="alert alert-danger" role="alert">
              {{ message }}
            </div>

            <div class="row justify-content-center">
              <div class="col-xl-10">
                <h4 class="text-primary text-capitalize">New Client Registration</h4>
                <p class="text-muted font-size-14 mb-4">
                  Fill In the details below to continue
                </p>

                <form>
                  <div class="row">
                    <div class="col-12">
                      <div class="mb-3">
                        <label for="digit1-input" class="visually-hidden">Full Names</label>
                        <input
                            v-model="localCustomerName"
                            type="text"
                            class="form-control text-center two-step"
                            placeholder="Full Names"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-3">
                        <label for="digit1-input" class="visually-hidden">Email</label>
                        <input
                            v-model="localEmail"
                            type="text"
                            class="form-control text-center two-step"
                            placeholder="Email"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-3">
                        <label for="digit1-input" class="visually-hidden">Phone Number</label>
                        <input
                            v-model="localPhoneNumber"
                            type="text"
                            class="form-control text-center two-step"
                            placeholder="Phone Number"
                        >
                      </div>
                    </div>
                  </div>

                  <button @click.prevent="handleRegister" type="button" class="btn btn-success btn-block w-100">
                    <i class="mdi-account-multiple-plus mdi font-size-16 align-middle me-2"></i>
                    Register Client
                  </button>

                  <button
                      style="display: none"
                      id="closeAddCustomerModal"
                      data-dismiss="modal"
                      type="button"
                      class="btn btn-success btn-block w-100"
                  >
                    close
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerRegistrationModal',

  props: {
    phoneNumber: {
      type: String,
      default: ''
    },
    customerName: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      localPhoneNumber: this.phoneNumber,
      localCustomerName: this.customerName,
      localEmail: this.email
    }
  },

  watch: {
    phoneNumber(newVal) {
      this.localPhoneNumber = newVal
    },
    customerName(newVal) {
      this.localCustomerName = newVal
    },
    email(newVal) {
      this.localEmail = newVal
    },
    localPhoneNumber(newVal) {
      this.$emit('update:phoneNumber', newVal)
    },
    localCustomerName(newVal) {
      this.$emit('update:customerName', newVal)
    },
    localEmail(newVal) {
      this.$emit('update:email', newVal)
    }
  },

  methods: {
    handleRegister() {
      this.$emit('register-customer', {
        phoneNumber: this.localPhoneNumber,
        customerName: this.localCustomerName,
        email: this.localEmail
      })
    }
  }
}
</script>